import { HttpErrorResponse } from '@angular/common/http';
import { PaymentAccount } from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, props } from '@ngrx/store';

export const PoaSelectPaymentMethodPaymentAccountActions = createActionGroup({
  source: 'POA Select Payment Method Component Payment Account',
  events: {
    'Create Payment Account Success': props<{
      payload: PaymentAccount;
    }>(),
    'Create Payment Account Error': props<{
      error: HttpErrorResponse;
    }>(),
    'Delete Payment Account Success': props<{
      paymentAccountBurn: string;
    }>(),
    'Delete Payment Account Failed': props<{
      paymentAccountBurn: string;
    }>(),
  },
});
